
import { GridFilterInputSingleSelect } from "@mui/x-data-grid";
import { castOptionsToFitOptionsFilter } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";

const GenericFilterForEnums = (options) => {
  return [
    {
      label: "is",
      value: "is",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) {
          return null; // no filter applied
        }
        return (params) => params.value === filterItem.value;
      },
      InputComponent: GridFilterInputSingleSelect,
      InputComponentProps: {
        valueOptions:castOptionsToFitOptionsFilter(options)
      },
    },
  ];
};

export default GenericFilterForEnums;
